import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import { ProtectionRiskType } from "@bienesis/common";

import { useApi } from "../client";
import keys from "./keys";
import {
  ActiveProtectionsResultHttp,
  AreaProtectionSummaryHttp,
} from "./types";

export const useActiveProtections = (areaId: string) => {
  const api = useApi();

  return useQuery({
    queryKey: keys.active(areaId),
    queryFn: async (): Promise<ActiveProtectionsResultHttp> => {
      const response = await api.get(`protection/${areaId}/active`);
      return response.json();
    },
  });
};

export const useProtectionSummary = ({
  areaId,
  riskType,
}: {
  areaId: string;
  riskType: ProtectionRiskType;
}) => {
  const api = useApi();

  return useInfiniteQuery({
    queryKey: keys.summary({ areaId, riskType }),
    queryFn: async ({ pageParam }): Promise<AreaProtectionSummaryHttp> => {
      const response = await api.post(
        `protection/protection-summary/${areaId}`,
        { json: { riskType, offset: pageParam } }
      );
      return response.json();
    },
    initialPageParam: 0,
    getNextPageParam: (lastPage, _, lastPageParam) => {
      const hasMore =
        lastPage.notificationEvents.hasMore ||
        lastPage.protectionActions.hasMore;
      if (!hasMore) return undefined;
      const itemCount = Math.max(
        lastPage.notificationEvents.items.length,
        lastPage.protectionActions.items.length
      );
      if (itemCount === 0) return undefined;
      return lastPageParam + itemCount;
    },
    retry: 0,
  });
};
